var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useEffect, useState } from 'react';
import env from 'kareo-environment-config';
import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';
import portal from './portalConfig';
import toggleCardDefault from './toggleCardDefault';
var abortController = new AbortController();
var EDIT_PAYMENT_METHOD_URL = portal.host(env) + "/api/kareo-payments/payment-methods";
function sortCards(cards) {
    var defaultCard = cards.find(function (card) { return card.defaultCard; });
    return __spreadArrays((defaultCard ? [defaultCard] : []), cards
        .filter(function (c) { return c !== defaultCard; })
        .sort(function (a, b) { return Number(a.paymentMethodId) - Number(b.paymentMethodId); }));
}
export var fetchCards = function (props) {
    var customerId = props.customerId, practiceGuid = props.practiceGuid, patientGuid = props.patientGuid;
    return kfetch(portal.host(env) + "/api/kareo-payments/cards", __assign({ body: JSON.stringify({
            AppId: portal.AppId,
            PracticeExternalId: customerId + "|" + practiceGuid,
            PatientExternalId: customerId + "|" + patientGuid,
        }), method: 'POST' }, portal.requestProps)).catch(function (error) { return rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(error); });
};
var INITIAL_CARDS = [];
var useCardsOnFile = function (props) {
    var _a = useState(INITIAL_CARDS), cards = _a[0], setCards = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(), error = _c[0], setError = _c[1];
    var customerId = props.customerId, practiceGuid = props.practiceGuid, patientGuid = props.patientGuid, onCardFetchedResponse = props.onCardFetchedResponse;
    var cardsLength = cards === null || cards === void 0 ? void 0 : cards.length;
    useEffect(function () {
        function fetchCardsEffect() {
            return __awaiter(this, void 0, void 0, function () {
                var response, newDefaultCard, editResponse_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading(true);
                            return [4 /*yield*/, fetchCards({
                                    customerId: customerId,
                                    practiceGuid: practiceGuid,
                                    patientGuid: patientGuid,
                                }).catch(function (err) {
                                    var _a;
                                    var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t fetch your saved cards. Please try again later, or contact support if you need help.');
                                    setError(parsedError);
                                    rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                                })];
                        case 1:
                            response = _a.sent();
                            if (!((response === null || response === void 0 ? void 0 : response.length) &&
                                !response.find(function (card) { return card.defaultCard; }))) return [3 /*break*/, 3];
                            newDefaultCard = response[0];
                            return [4 /*yield*/, toggleCardDefault({
                                    card: newDefaultCard,
                                    customerId: customerId,
                                    patientGuid: patientGuid,
                                    practiceGuid: practiceGuid,
                                    defaultCard: true,
                                })
                                    .catch(function (err) {
                                    // @ts-ignore
                                    if (err.body.message !== 'Unable to update stripe card') {
                                        setError(err);
                                        return true;
                                    }
                                    rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(err);
                                    return false;
                                })
                                    .finally(function () {
                                    setLoading(false);
                                })];
                        case 2:
                            editResponse_1 = _a.sent();
                            setCards(response.map(function (card) {
                                if ((card === null || card === void 0 ? void 0 : card.paymentMethodId) === editResponse_1.paymentMethodId) {
                                    return editResponse_1;
                                }
                                else {
                                    return card;
                                }
                            }));
                            return [3 /*break*/, 4];
                        case 3:
                            setCards(response);
                            if (onCardFetchedResponse) {
                                onCardFetchedResponse(response);
                            }
                            _a.label = 4;
                        case 4:
                            setLoading(false);
                            return [2 /*return*/, function () { return abortController.abort(); }];
                    }
                });
            });
        }
        if (customerId && patientGuid && practiceGuid) {
            fetchCardsEffect();
        }
    }, [
        customerId,
        practiceGuid,
        patientGuid,
        cardsLength,
        onCardFetchedResponse,
    ]);
    var removeCard = function (savedCard) { return __awaiter(void 0, void 0, void 0, function () {
        var response, updatedSavedCards, newDefaultResponse_1, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, kfetch(portal.host(env) + "/api/kareo-payments/cards/delete", __assign({ method: 'POST', body: JSON.stringify({
                                AppId: portal.AppId,
                                PracticeExternalId: (customerId + "|" + practiceGuid).toUpperCase(),
                                PatientExternalId: (customerId + "|" + patientGuid).toUpperCase(),
                                PaymentMethodId: savedCard.paymentMethodId,
                            }) }, portal.requestProps))
                            .catch(function (err) {
                            var _a;
                            var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t delete your card. Please contact support if you need help.');
                            setError(parsedError);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                        })
                            .finally(function () {
                            setLoading(false);
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 4];
                    updatedSavedCards = cards.filter(function (card) { return card.paymentMethodId !== savedCard.paymentMethodId; });
                    if (!(savedCard.defaultCard && updatedSavedCards.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, toggleCardDefault({
                            card: updatedSavedCards[0],
                            customerId: customerId,
                            patientGuid: patientGuid,
                            practiceGuid: practiceGuid,
                            defaultCard: true,
                        }).catch(function (err) {
                            setError(err);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(err);
                        })];
                case 2:
                    newDefaultResponse_1 = _a.sent();
                    if (newDefaultResponse_1) {
                        setCards(updatedSavedCards.map(function (card) {
                            if (card.paymentMethodId === newDefaultResponse_1.paymentMethodId) {
                                return newDefaultResponse_1;
                            }
                            else {
                                return card;
                            }
                        }));
                    }
                    else {
                        err = new Error('Unable to create a new default card');
                        setError(err);
                        rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(err);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setCards(updatedSavedCards);
                    _a.label = 4;
                case 4: return [2 /*return*/, response];
            }
        });
    }); };
    var updateCard = function (card) { return __awaiter(void 0, void 0, void 0, function () {
        var address1, addressCity, addressState, addressZipcode, expirationMonth, expirationYear, defaultCard, name, nickname, note, paymentMethodId, requestConfig, editedCardResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address1 = card.address1, addressCity = card.addressCity, addressState = card.addressState, addressZipcode = card.addressZipcode, expirationMonth = card.expirationMonth, expirationYear = card.expirationYear, defaultCard = card.defaultCard, name = card.name, nickname = card.nickname, note = card.note, paymentMethodId = card.paymentMethodId;
                    requestConfig = __assign({ body: JSON.stringify({
                            Address1: address1,
                            Address2: '',
                            AddressCity: addressCity,
                            AddressState: addressState,
                            AddressZipcode: addressZipcode,
                            AppId: portal.AppId,
                            DefaultCard: defaultCard,
                            ExpirationMonth: expirationMonth,
                            ExpirationYear: expirationYear,
                            Name: name,
                            Nickname: nickname,
                            Note: note,
                            PatientExternalId: customerId + "|" + patientGuid,
                            PaymentMethodId: paymentMethodId,
                            PracticeExternalId: customerId + "|" + practiceGuid,
                        }), method: 'POST' }, portal.requestProps);
                    setLoading(true);
                    return [4 /*yield*/, kfetch(portal.host(env) + "/api/kareo-payments/cards/edit-card", requestConfig)
                            .catch(function (err) {
                            var _a;
                            var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t update your card. Please check your details and try again, or contact support if you need help.');
                            setError(parsedError);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                        })
                            .finally(function () {
                            setLoading(false);
                        })];
                case 1:
                    editedCardResponse = _a.sent();
                    if (editedCardResponse) {
                        // trigger a re-render
                        setCards([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var addCard = function (card) { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, requestBodyStringified, requestConfig, newCardResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        AppId: portal.AppId,
                        DefaultCard: !!card.defaultCard,
                        PracticeExternalId: customerId + "|" + practiceGuid,
                        PatientExternalId: customerId + "|" + patientGuid,
                        Token: card.token,
                        Nickname: card.nickname,
                        Note: card.note,
                    };
                    requestBodyStringified = JSON.stringify(requestBody);
                    requestConfig = __assign({ body: requestBodyStringified, method: 'POST' }, portal.requestProps);
                    return [4 /*yield*/, kfetch(portal.host(env) + "/api/kareo-payments/cards/new-card", requestConfig).catch(function (err) {
                            var _a;
                            var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t save your card. Please check your details and try again, or contact support if you need help.');
                            setError(parsedError);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                        })];
                case 1:
                    newCardResponse = _a.sent();
                    if (newCardResponse) {
                        if (newCardResponse.defaultCard) {
                            setCards(__spreadArrays(cards.map(function (c) { return (__assign(__assign({}, c), { defaultCard: false })); }), [
                                newCardResponse,
                            ]));
                        }
                        else {
                            setCards(__spreadArrays(cards, [newCardResponse]));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var updatePaymentMethod = function (card) { return __awaiter(void 0, void 0, void 0, function () {
        var address1, addressCity, addressState, addressZipcode, expirationMonth, expirationYear, defaultCard, name, nickname, note, paymentMethodId, requestConfig, editPaymentMethod;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address1 = card.address1, addressCity = card.addressCity, addressState = card.addressState, addressZipcode = card.addressZipcode, expirationMonth = card.expirationMonth, expirationYear = card.expirationYear, defaultCard = card.defaultCard, name = card.name, nickname = card.nickname, note = card.note, paymentMethodId = card.paymentMethodId;
                    requestConfig = __assign({ body: JSON.stringify({
                            Address1: address1,
                            Address2: '',
                            AddressCity: addressCity,
                            AddressState: addressState,
                            AddressPostalCode: addressZipcode,
                            AppId: portal.AppId,
                            DefaultCard: defaultCard,
                            ExpirationMonth: expirationMonth,
                            ExpirationYear: expirationYear,
                            Name: name,
                            Nickname: nickname,
                            Note: note,
                            PatientExternalId: customerId + "|" + patientGuid,
                            PaymentMethodId: paymentMethodId,
                            PracticeExternalId: customerId + "|" + practiceGuid,
                        }), method: 'PUT' }, portal.requestProps);
                    setLoading(true);
                    return [4 /*yield*/, kfetch(EDIT_PAYMENT_METHOD_URL + "/" + paymentMethodId, requestConfig)
                            .catch(function (err) {
                            var _a;
                            var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t update your card. Please check your details and try again, or contact support if you need help.');
                            setError(parsedError);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                        })
                            .finally(function () {
                            setLoading(false);
                        })];
                case 1:
                    editPaymentMethod = _a.sent();
                    if (editPaymentMethod) {
                        // trigger a re-render
                        setCards([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var removePaymentMethod = function (savedCard) { return __awaiter(void 0, void 0, void 0, function () {
        var response, updatedSavedCards, newDefaultResponse_2, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, kfetch(portal.host(env) + "/api/kareo-payments/payment-methods", __assign({ method: 'DELETE', body: JSON.stringify({
                                AppId: portal.AppId,
                                PracticeExternalId: (customerId + "|" + practiceGuid).toUpperCase(),
                                PatientExternalId: (customerId + "|" + patientGuid).toUpperCase(),
                                PaymentMethodId: savedCard.paymentMethodId,
                            }) }, portal.requestProps))
                            .catch(function (err) {
                            var _a;
                            var parsedError = new Error(((_a = err === null || err === void 0 ? void 0 : err.body) === null || _a === void 0 ? void 0 : _a.message) || 'We couldn’t remove your card. Please contact support if you need help.');
                            setError(parsedError);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(parsedError);
                        })
                            .finally(function () {
                            setLoading(false);
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 4];
                    updatedSavedCards = cards.filter(function (card) { return card.paymentMethodId !== savedCard.paymentMethodId; });
                    if (!(savedCard.defaultCard && updatedSavedCards.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, toggleCardDefault({
                            card: updatedSavedCards[0],
                            customerId: customerId,
                            patientGuid: patientGuid,
                            practiceGuid: practiceGuid,
                            defaultCard: true,
                        }).catch(function (err) {
                            // @ts-ignore
                            if (err.body.message !== 'Unable to update stripe card') {
                                setError(err);
                            }
                            setLoading(false);
                            rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(err);
                        })];
                case 2:
                    newDefaultResponse_2 = _a.sent();
                    if (newDefaultResponse_2) {
                        setCards(updatedSavedCards.map(function (card) {
                            if (card.paymentMethodId === newDefaultResponse_2.paymentMethodId) {
                                return newDefaultResponse_2;
                            }
                            else {
                                return card;
                            }
                        }));
                    }
                    else {
                        err = new Error('Unable to create a new default card');
                        setError(err);
                        rollbar === null || rollbar === void 0 ? void 0 : rollbar.error(err);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setCards(updatedSavedCards);
                    _a.label = 4;
                case 4: return [2 /*return*/, response];
            }
        });
    }); };
    var tuple = {
        cards: sortCards(cards),
        error: error,
        loading: loading,
        addCard: addCard,
        removeCard: removeCard,
        updateCard: updateCard,
        updatePaymentMethod: updatePaymentMethod,
        removePaymentMethod: removePaymentMethod,
    };
    return tuple;
};
export default useCardsOnFile;
